import { render, staticRenderFns } from "./VerDetalleTipoDispositivoModal.vue?vue&type=template&id=fade8afc&"
import script from "./VerDetalleTipoDispositivoModal.vue?vue&type=script&lang=ts&"
export * from "./VerDetalleTipoDispositivoModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('fade8afc', component.options)
    } else {
      api.reload('fade8afc', component.options)
    }
    module.hot.accept("./VerDetalleTipoDispositivoModal.vue?vue&type=template&id=fade8afc&", function () {
      api.rerender('fade8afc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/TipoDispositivo/VerDetalleTipoDispositivoModal.vue"
export default component.exports